import { render, staticRenderFns } from "./Inbox.vue?vue&type=template&id=7475f3a8&"
import script from "./Inbox.vue?vue&type=script&lang=js&"
export * from "./Inbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports